var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mt-1",attrs:{"height":"auto"}},[(_vm.iframe)?_c('iframe',{style:(_vm.iframe.style),attrs:{"src":_vm.iframe.src,"height":_vm.iframe.height,"width":_vm.iframe.width,"type":"application/pdf","frameborder":"0"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }